/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  AccountBalance,
  AccountBalanceInterface,
} from "../AccountBalance";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "clearingHouse",
        type: "address",
      },
    ],
    name: "ClearingHouseChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "amount",
        type: "int256",
      },
    ],
    name: "PnlRealized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "vault",
        type: "address",
      },
    ],
    name: "VaultChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "deregisterBaseToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getAccountInfo",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "takerPositionSize",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "takerOpenNotional",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "lastTwPremiumGrowthGlobalX96",
            type: "int256",
          },
        ],
        internalType: "struct AccountMarket.Info",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getBase",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getBaseTokens",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getClearingHouse",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getClearingHouseConfig",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        internalType: "int256",
        name: "accountValue",
        type: "int256",
      },
    ],
    name: "getLiquidatablePositionSize",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getMarginRequirementForLiquidation",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getMarkPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getOrderBook",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getPnlAndPendingFee",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getQuote",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getTakerOpenNotional",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getTakerPositionSize",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getTotalAbsPositionValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getTotalDebtValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getTotalOpenNotional",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getTotalPositionSize",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getTotalPositionValue",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getVault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "hasOrder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "clearingHouseConfigArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "orderBookArg",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "int256",
        name: "amount",
        type: "int256",
      },
    ],
    name: "modifyOwedRealizedPnl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        internalType: "int256",
        name: "base",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "quote",
        type: "int256",
      },
    ],
    name: "modifyTakerBalance",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "registerBaseToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "clearingHouseArg",
        type: "address",
      },
    ],
    name: "setClearingHouse",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "vaultArg",
        type: "address",
      },
    ],
    name: "setVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        internalType: "int256",
        name: "takerBase",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "takerQuote",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "realizedPnl",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "makerFee",
        type: "int256",
      },
    ],
    name: "settleBalanceAndDeregister",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "settleOwedRealizedPnl",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "settlePositionInClosedMarket",
    outputs: [
      {
        internalType: "int256",
        name: "positionNotional",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "openNotional",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "realizedPnl",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "closedPrice",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        internalType: "int256",
        name: "amount",
        type: "int256",
      },
    ],
    name: "settleQuoteToOwedRealizedPnl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        internalType: "int256",
        name: "lastTwPremiumGrowthGlobalX96",
        type: "int256",
      },
    ],
    name: "updateTwPremiumGrowthGlobal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class AccountBalance__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<AccountBalance> {
    return super.deploy(overrides || {}) as Promise<AccountBalance>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): AccountBalance {
    return super.attach(address) as AccountBalance;
  }
  connect(signer: Signer): AccountBalance__factory {
    return super.connect(signer) as AccountBalance__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AccountBalanceInterface {
    return new utils.Interface(_abi) as AccountBalanceInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AccountBalance {
    return new Contract(address, _abi, signerOrProvider) as AccountBalance;
  }
}
